import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "text-h5 text-dark" }
const _hoisted_3 = { class: "content overflow-auto" }
const _hoisted_4 = { class: "q-pa-none header" }

import { computed } from "vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'DialogContainer',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'md'
    },
    title: {
      type: String,
      default: null
    },
    maximized: {
      type: Boolean,
      default: false
    },
    close: {
      type: Boolean,
      default: false
    },
    fullHeight: {
      type: Boolean,
      default: true
    }
  },
  emits: [
    'update:modelValue'
  ],
  setup(__props, { emit: __emit }) {

  const props = __props

  const value = computed<boolean>({
    get() {
      if (props.modelValue) {
        return props.modelValue
      }
      else {
        return false
      }
    },
    set(value: boolean) {
      emit('update:modelValue', value)
    }
  })

  const emit = __emit

  const style = computed(() => {
    switch (props.size) {
      case 'sm':

        break;
      case 'md':
        return {
          'width': '794px',
          'max-width': '100%',
          'max-height': props.maximized ? 'unset' : '80vh'
        }
        break;
    }
  })


return (_ctx: any,_cache: any) => {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: value.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event)),
    maximized: __props.maximized
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["flex items-center", __props.fullHeight === true ? 'full-height' : ''])
      }, [
        _createElementVNode("div", {
          style: _normalizeStyle(style.value),
          class: "box-column bg-white rounded-borders full-height"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    (__props.close === true)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          round: "",
                          flat: "",
                          dense: "",
                          icon: "close",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (value.value = false))
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_q_separator),
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "buttons")
          ])
        ], 4)
      ], 2)
    ]),
    _: 3
  }, 8, ["modelValue", "maximized"]))
}
}

})